<template>
  <div class="app-main-content">
    <verify-tree-grid
      v-show="view==='list'"
      ref="verifyTreeGrid"
      :context="context"
      :use-order-center-mode="useOrderCenterMode"
      :order-center-branch="useOrderCenterBranch"
      :approve-cooperation-business="approveCooperationBusiness"
      @look="lookHandle"
      @edit="editHandle"
      @add="addHandle"
      @copy="copyHandle"
      @refresh="refreshHandle"
    />
    <verify-workspace
      v-show="view==='detail'"
      ref="verifyWorkspace"
      :parent-context="context"
      :use-order-center-mode="useOrderCenterMode"
      :approve-cooperation-business="approveCooperationBusiness"
      @add="addHandle"
      @edit="editHandle"
      @copy="copyHandle"
      @back="backToList"
    />
    <job-no-rule-selector
      ref="jobNoRuleSelector"
      :visible.sync="jobNoRule.visible"
      :rules="jobNoRule.rules || []"
      @selectedBack="jobNoRule.action === 'add' ? doAddJob : doCopyJob"
    />
  </div>
</template>

<script>
import { BookingVerifyContext } from './components/verify/bookingVerifyContext'
import jobNoRuleSelector from '@/components/Cargo/Job/jobNoRuleSelector'
import verifyTreeGrid from './components/verify/verifyTreeGrid'
import verifyWorkspace from './components/verify/verifyWorkspace'
import { ErrorTip } from '@/utils/class/ErrorTip'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { queryJobNoRule, isContractExpiredForbidCreateJob, doCopyJob, advancedQuery } from '@/api/railwayExport/reBooking'
import { getLoading } from '@/utils/utilBaseElement'
import { RailwayExportJob } from '@/class/model/booking/RailwayExportJob'
import lodash from 'lodash'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { JOB_STATES, REMOTE_BOOKING_ALL_STATES } from '@/class/cargo/model/parameters/SystemConstants'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import { JumpUtil } from '@/utils/JumpUtil'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'

export default {
  name: 'ReBookingVerify',
  components: { verifyTreeGrid, verifyWorkspace, jobNoRuleSelector },
  data() {
    return {
      loading: null,
      context: BookingVerifyContext.getInstance(),
      view: 'list',
      job: null, // 复制使用
      jobNoRule: {
        visible: false,
        action: 'add',
        rules: ''
      }
    }
  },
  computed: {
    officeId() {
      return this.$store.getters.currentOfficeId
    },
    office() {
      return this.context.office
    },
    useOrderCenterMode() { // 是否开启接单中心模式
      return this.context.config ? Number(this.context.config.get('useOrderCenterMode')) === 1 : false
    },
    useOrderCenterBranch() { // 是否开启接单分公司
      return this.context.config ? Number(this.context.config.get('orderCenterBranch')) === 1 : false
    },
    approveCooperationBusiness() { // 是否协作分公司需审核接单分公司的协作业务
      return this.context.config ? Number(this.context.config.get('approveCooperationBusiness')) === 1 : false
    }
  },
  watch: {
    officeId: {
      async handler() {
        if (this.office.officeId !== this.officeId) {
          await this.context.prepareData()
        }
      }
    }
  },
  created() {
    this.context.prepareData()
  },
  errorCaptured(err) {
    if (err instanceof ErrorTip) {
      this.$message({ message: err.message, type: err.type })
      return false
    }
    return true
  },
  activated() {
    if (this.$route.query.jobNo) {
      this.toDetail(this, this.$route.query.jobNo)
      location.replace(location.href.replace(location.hash, `#${this.$route.path}`))
    } else if (this.$route.params.jobNos) {
      const filter = {
        conditions: [
          new AdvancedSearchOption(null, 'job.PREVERIFY_STATE', [0, 1, 2, 3], AdvancedSearchConsts.OPERATOR_IN.code).formatObj2Json(),
          new AdvancedSearchOption(null, 'job.JOB_STATE', SystemConstants.STATE_VERIFYING.code).formatObj2Json()
        ]
      }
      JumpUtil.jumpToTab(advancedQuery, filter, this.$route.params, this, 'verifyWorkspace')
    }
  },
  methods: {
    lookHandle(row) {
      this.detailHandle('look', row)
    },
    editHandle(row) {
      if (!row) {
        return
      }
      // 协作状态
      if (row.cooperateStatus !== -1 && this.useOrderCenterMode && this.approveCooperationBusiness) {
        if (row.cooperateStatus !== SystemConstants.COOPERATE_STATUS_APPROVED.code) {
          const cooperateStatusStr = JobUtils.getStateName(row.cooperateStatus, SystemConstants.COOPERATE_STATUS)
          this.$message.warning(this.$t('Message.CanNotEditJob', [this.$t('CargoMsg.Cargo_CooperateStatus') + cooperateStatusStr]))
          return
        }
        this.detailHandle('edit', row)
        return
      }
      const stateStr = JobUtils.getStateName(row.preverifyState, REMOTE_BOOKING_ALL_STATES)
      // 开启，预审状态为待审核、已审核 允许编辑
      const pretrialReviewConfig = parseInt(this.context.config.get('PretrialReview')) === 1
      if (pretrialReviewConfig) {
        if (![1, 2].includes(row.preverifyState)) {
          this.$message.warning(this.$t('Message.CanNotEditJob', [stateStr]))
          return
        }
        if (![-1, 0].includes(row.jobState)) {
          const stateStr = JobUtils.getStateName(row.jobState, JOB_STATES)
          this.$message.warning(this.$t('Message.CanNotEditJob', [stateStr]))
          return
        }
      } else {
        // 不开启，预审状态为待审核的允许编辑
        if (row.preverifyState !== 1) {
          this.$message.warning(this.$t('Message.CanNotEditJob', [stateStr]))
          return
        }
      }
      this.detailHandle('edit', row)
    },
    addHandle() {
      if (!this.checkOfficeId()) return
      this.confirmCallBackHandler('add')
    },
    backToList(isRefresh) {
      this.$refs.verifyTreeGrid.$el.style.display = 'flex'
      this.$refs.verifyWorkspace.$el.style.display = 'none'
      const rowData = this.$refs.verifyWorkspace.rowData
      this.view = 'list'
      if (isRefresh) {
        this.$refs.verifyTreeGrid.toQuery(rowData)
      }
    },
    // 复制
    copyHandle(row) {
      if (!row) return
      this.job = row
      if (!this.checkOfficeId()) return
      if (row.customerId) {
        isContractExpiredForbidCreateJob(row.customerId).then(res => {
          if (res && res.data) {
            this.$message.warning(this.$t('Message.ContractExpireCannotCreated'))
            return
          } else {
            this.confirmCallBackHandler('copy')
          }
        })
      }
    },
    doCopyJob(jobNoRule) {
      const item = {}
      item.jobRule = !jobNoRule ? '' : jobNoRule.uuid
      item.jobUuid = this.job.uuid
      item.branchId = this.$store.getters.currentOfficeId
      item.copyNum = 1
      item.all = false
      item.source = 'bookingVerify'
      this.loading = getLoading()
      doCopyJob(item).then(async res => {
        this.loading.close()
        const newJob = res.data
        newJob.opOffice = this.$store.getters.currentOfficeId || newJob.opOffice
        newJob.planner = 0
        newJob.soNo = ''
        newJob.bookingNo = ''
        newJob.returnPeriodBegin = ''
        newJob.returnPeriodEnd = ''
        newJob.fileCutoff = ''
        const continueExec = await JobUtils.validateJobFieldActive(newJob, this, 'BookingVerify')
        if (!continueExec) {
          return
        }
        this.$logger.log('复制-new job', newJob)
        this.detailHandle('copy', newJob)
      })
    },
    confirmCallBackHandler(action) {
      if (String(this.context.config.get('UseNewJobNoRule')) === '1') {
        this.loading = getLoading()
        queryJobNoRule(SystemConstants.SE.code).then(res => {
          this.loading.close()
          this.ruleResultHandler(res, action)
        })
      } else {
        action === 'copy' ? this.doCopyJob() : this.doAddJob()
      }
    },
    ruleResultHandler(event, action) {
      const rules = event.data
      if (rules && rules.length > 1) {
        this.jobNoRule.rules = rules
        this.jobNoRule.action = action
        this.jobNoRule.visible = true
      } else if (rules && rules.length > 0) {
        action === 'copy' ? this.doCopyJob(rules[0]) : this.doAddJob(rules[0])
      } else {
        this.$message.warning(this.$t('SeaExport.MaintainJobNoRule'))
        return
      }
    },
    doAddJob(jobNoRule) {
      this.detailHandle('add', { jobNoRule: !jobNoRule ? '' : jobNoRule.uuid })
    },
    // 进详情公共
    detailHandle(type, row) {
      let rowData = null
      if (this.view === 'detail') {
        rowData = this.$refs.verifyWorkspace.rowData
      } else {
        rowData = this.getNewDetailData()
        this.view = 'detail'
      }
      if (row.uuid) {
        row = rowData.find(p => p.uuid === row.uuid)
      } else {
        new RailwayExportJob(row).fillDefaultValue() // 数据补充完整
        row.version = 0 // 版本号置为0，重新加载job
        row = { ...row } // 需重新构造对象，以便新增加的属性可以被vue监听到
      }
      this.$refs.verifyWorkspace.onShow(type, rowData, row)
    },
    // 操作成功后刷新详情
    refreshHandle(row) {
      row.isCompleteRow = false
      this.detailHandle('look', row)
    },
    checkOfficeId() {
      if (!this.office) {
        this.$message.warning(this.$t('Message.CurrentBranchIsNotSelectedCannotAddNewBookings'))
        return false
      }
      if (this.office.officeId === 1) {
        this.$message.warning(this.$t('Message.CompanySelectedIsHQCannotAddNewBookings'))
        return false
      }
      return true
    },
    getNewDetailData() {
      let rowData = []
      this.$refs.verifyTreeGrid.gridOptions.api.forEachNodeAfterFilterAndSort(node => {
        if (node.data) {
          rowData.push(node.data)
        }
      })
      rowData = lodash.cloneDeep(rowData)
      for (const item of rowData) {
        new RailwayExportJob(item).fillDefaultValue() // 数据补充完整
        item.version = 0 // 版本号置为0，重新加载job
      }
      return rowData
    },
    // 查询job后跳转详情
    toDetail(vm, jobNo) {
      const filter = {}
      filter.conditions = [
        new AdvancedSearchOption(null, 'job.JOB_NO', jobNo, '=').formatObj2Json()
      ]
      filter.branchId = this.$store.getters.currentOfficeId
      filter.pageNum = 1
      filter.requires = ['railwayBookingVerify'],
      vm.view = 'detail'
      advancedQuery(filter).then(res => {
        const rowData = res.data.list
        if (rowData && rowData.length > 0) {
          const index = rowData.findIndex(p => p.jobNo === jobNo)
          if (index > 0) {
            vm.$refs.verifyWorkspace.onShow('look', rowData, rowData[index])
          } else {
            vm.$refs.verifyWorkspace.onShow('look', rowData, rowData[0])
          }
        } else {
          vm.$message.error(vm.$t('Message.NoRecordMeetTheConditions'))
          vm.$refs.verifyWorkspace.goBack()
        }
      }).catch(() => {
        vm.$message.error(this.$t('Message.JumpFailed'))
      })
    }
  }
}
</script>
